export default "__VITE_ASSET__B77NPNhk__"